<template>
	<div class="company-oems-card-edit" :value="value">
		<span class="company-oems-card__item">
			<Dropdown
				label="Manufacturer"
				v-model="localData.manufacturer"
				:options="manufacturerOptions"
			/>
		</span>
		<span class="company-oems-card__item">
			<Dropdown
				label="Module"
				v-model="localData.module"
				:options="moduleOptions"
			/>
		</span>
		<span class="company-oems-card__item">
			<Dropdown
				label="Order Source"
				v-model="localData.order"
				:options="orderOptions"
			/>
		</span>
		<Toggle label="Active" v-model="status" />
		<Button
			className="btn--icon-only"
			iconClassName="icon-delete-glenn"
			:iconBeforeLabel="true"
		/>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Button from '@/components/forms/button/button';
import _ from 'lodash';

export default {
	name: 'CompanyOEMSCardEdit',
	components: { Dropdown, Toggle, Button },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			status: false,
			manufacturerOptions: [
				{
					text: 'BMW',
					value: 'bmw'
				},
				{
					text: 'AUDI',
					value: 'audi'
				},
				{
					text: 'GMC',
					value: 'gmc'
				}
			],
			moduleOptions: [
				{
					text: 'Parts',
					value: 'parts'
				},
				{
					text: 'Service',
					value: 'service'
				}
			],
			orderOptions: [
				{
					text: '1-Jeep Chemicals',
					value: '1-Jeep Chemicals'
				},
				{
					text: '2-Mercedes Stock',
					value: '2-Mercedes Stock'
				}
			]
		};
	},
	created() {
		this.status = !this.localData.inactive;
		console.log(this.value);
	},
	methods: {
		emitNewValues() {
			this.localData.inactive = !this.status;
			this.$emit('update', this.localData);
			this.$emit('input', this.localData);
		}
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.emitNewValues();
			}
		},
		status() {
			this.emitNewValues();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-oems-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
